<template>
      <div class="topbar">
            
            <!-- LOGO -->
            <div class="topbar-left">
                  <a href="index.html" class="logo">
                                        <span>
                                            <img src="images/logo-light-icon.png" alt="" width="80%">
                                        </span>
                        <i>
                              <img src="assets/images/logo-light-icon.png" alt="" height="28">
                        </i>
                  </a>
            </div>
            
            <nav class="navbar-custom">
                  
                  <ul class="list-unstyled topbar-right-menu float-right mb-0">
                        <!--
                        <li class="dropdown notification-list hide-phone">
                              <a class="nav-link dropdown-toggle waves-effect waves-light nav-user" data-toggle="dropdown" href="#" role="button"
                                 aria-haspopup="false" aria-expanded="false">
                                    <i class="mdi mdi-earth"></i> 中文版  <i class="mdi mdi-chevron-down"></i>
                              </a>
                              <div class="dropdown-menu dropdown-menu-right">
                                    
                                    
                                    <a href="javascript:void(0);" class="dropdown-item">
                                          中文版
                                    </a>
                                    
                              
                              </div>
                        </li>
                        
                        <li class="dropdown notification-list">
                              <a class="nav-link dropdown-toggle arrow-none waves-light waves-effect" data-toggle="dropdown" href="#" role="button"
                                 aria-haspopup="false" aria-expanded="false">
                                    <i class="fi-bell noti-icon"></i>
                                    <span class="badge badge-danger badge-pill noti-icon-badge">4</span>
                              </a>
                              <div class="dropdown-menu dropdown-menu-right dropdown-lg">
                                    
                                  
                                    <div class="dropdown-item noti-title">
                                          <h6 class="m-0"><span class="float-right"><a href="" class="text-dark"><small>Clear All</small></a> </span>Notification</h6>
                                    </div>
                                    
                                    <div class="slimscroll" style="max-height: 190px;">
                                         
                                          <a href="javascript:void(0);" class="dropdown-item notify-item">
                                                <div class="notify-icon bg-success"><i class="mdi mdi-comment-account-outline"></i></div>
                                                <p class="notify-details">Caleb Flakelar commented on Admin<small class="text-muted">1 min ago</small></p>
                                          </a>
                                          
                                         
                                          <a href="javascript:void(0);" class="dropdown-item notify-item">
                                                <div class="notify-icon bg-info"><i class="mdi mdi-account-plus"></i></div>
                                                <p class="notify-details">New user registered.<small class="text-muted">5 hours ago</small></p>
                                          </a>
                                          
                                         
                                          <a href="javascript:void(0);" class="dropdown-item notify-item">
                                                <div class="notify-icon bg-danger"><i class="mdi mdi-heart"></i></div>
                                                <p class="notify-details">Carlos Crouch liked <b>Admin</b><small class="text-muted">3 days ago</small></p>
                                          </a>
                                          
                                         
                                          <a href="javascript:void(0);" class="dropdown-item notify-item">
                                                <div class="notify-icon bg-warning"><i class="mdi mdi-comment-account-outline"></i></div>
                                                <p class="notify-details">Caleb Flakelar commented on Admin<small class="text-muted">4 days ago</small></p>
                                          </a>
                                          
                                          
                                          <a href="javascript:void(0);" class="dropdown-item notify-item">
                                                <div class="notify-icon bg-purple"><i class="mdi mdi-account-plus"></i></div>
                                                <p class="notify-details">New user registered.<small class="text-muted">7 days ago</small></p>
                                          </a>
                                          
                                         
                                          <a href="javascript:void(0);" class="dropdown-item notify-item">
                                                <div class="notify-icon bg-custom"><i class="mdi mdi-heart"></i></div>
                                                <p class="notify-details">Carlos Crouch liked <b>Admin</b><small class="text-muted">13 days ago</small></p>
                                          </a>
                                    </div>
                                    
                                  
                                    <a href="javascript:void(0);" class="dropdown-item text-center text-primary notify-item notify-all">
                                          View all <i class="fi-arrow-right"></i>
                                    </a>
                              
                              </div>
                        </li>
                        
                        <li class="dropdown notification-list">
                              <a class="nav-link dropdown-toggle arrow-none waves-light waves-effect" data-toggle="dropdown" href="#" role="button"
                                 aria-haspopup="false" aria-expanded="false">
                                    <i class="fi-speech-bubble noti-icon"></i>
                                    <span class="badge badge-light badge-pill noti-icon-badge">6</span>
                              </a>
                              <div class="dropdown-menu dropdown-menu-right dropdown-lg">
                                    
                              
                                    <div class="dropdown-item noti-title">
                                          <h6 class="m-0"><span class="float-right"><a href="" class="text-dark"><small>Clear All</small></a> </span>Chat</h6>
                                    </div>
                                    
                                    <div class="slimscroll" style="max-height: 190px;">
                                         
                                          <a href="javascript:void(0);" class="dropdown-item notify-item">
                                                <div class="notify-icon"><img src="assets/images/users/avatar-2.jpg" class="img-fluid rounded-circle" alt="" /> </div>
                                                <p class="notify-details">Cristina Pride</p>
                                                <p class="text-muted font-13 mb-0 user-msg">Hi, How are you? What about our next meeting</p>
                                          </a>
                                          
                                      
                                          <a href="javascript:void(0);" class="dropdown-item notify-item">
                                                <div class="notify-icon"><img src="assets/images/users/avatar-3.jpg" class="img-fluid rounded-circle" alt="" /> </div>
                                                <p class="notify-details">Sam Garret</p>
                                                <p class="text-muted font-13 mb-0 user-msg">Yeah everything is fine</p>
                                          </a>
                                          
                                          
                                          <a href="javascript:void(0);" class="dropdown-item notify-item">
                                                <div class="notify-icon"><img src="assets/images/users/avatar-4.jpg" class="img-fluid rounded-circle" alt="" /> </div>
                                                <p class="notify-details">Karen Robinson</p>
                                                <p class="text-muted font-13 mb-0 user-msg">Wow that's great</p>
                                          </a>
                                          
                                        
                                          <a href="javascript:void(0);" class="dropdown-item notify-item">
                                                <div class="notify-icon"><img src="assets/images/users/avatar-5.jpg" class="img-fluid rounded-circle" alt="" /> </div>
                                                <p class="notify-details">Sherry Marshall</p>
                                                <p class="text-muted font-13 mb-0 user-msg">Hi, How are you? What about our next meeting</p>
                                          </a>
                                          
                                         
                                          <a href="javascript:void(0);" class="dropdown-item notify-item">
                                                <div class="notify-icon"><img src="assets/images/users/avatar-6.jpg" class="img-fluid rounded-circle" alt="" /> </div>
                                                <p class="notify-details">Shawn Millard</p>
                                                <p class="text-muted font-13 mb-0 user-msg">Yeah everything is fine</p>
                                          </a>
                                    </div>
                                    
                                
                                    <a href="javascript:void(0);" class="dropdown-item text-center text-primary notify-item notify-all">
                                          View all <i class="fi-arrow-right"></i>
                                    </a>
                              
                              </div>
                        </li>
                        -->
                        <li class="dropdown notification-list">
                              <a class="nav-link dropdown-toggle arrow-none waves-light waves-effect" href="#/main?show=2" >
                                    <i class="fi-bell noti-icon"></i>
                                    <span class="badge badge-danger badge-pill noti-icon-badge" v-if="num!=0">{{num}}</span>
                              </a>
                        </li>
                        <li class="dropdown notification-list">
                              <a class="nav-link dropdown-toggle waves-effect waves-light nav-user" data-toggle="dropdown" href="#" role="button"
                                 aria-haspopup="false" aria-expanded="false">
                                    <span class="ml-1">{{lisname}} <i class="mdi mdi-chevron-down"></i> </span>
                              </a>
                              <div class="dropdown-menu dropdown-menu-right profile-dropdown ">
                                    
                                    <div class="dropdown-item noti-title">
                                          <h6 class="text-overflow m-0">Welcome !</h6>
                                    </div>
                                    
                                    
                                    <a href="#/password" class="dropdown-item notify-item">
                                          <i class="mdi mdi-lock-open"></i> <span>修改密码</span>
                                    </a>
                                    
                                    
                                    <a href="javascript:void(0);" class="dropdown-item notify-item" v-on:click="kefu">
                                          <i class="mdi mdi-headset"></i> <span>在线客服</span>
                                    </a>
                                    
                                    
                                    <a href="#/loginout" class="dropdown-item notify-item">
                                          <i class="mdi mdi-power"></i> <span>退出</span>
                                    </a>
                                    
                                    
                              
                              </div>
                        </li>
                  
                  </ul>
                  
                  <ul class="list-inline menu-left mb-0">
                        <li class="float-left">
                              <button class="button-menu-mobile open-left waves-light waves-effect">
                                    <i class="dripicons-menu"></i>
                              </button>
                        </li>
      
                        <li class="hide-phone app-search" style="color: #ffffff;font-size: 24px;">
                              特许私人财富管理师考试与认证系统
                        </li>
                        
                        
                  </ul>
            
            </nav>
      
      </div>

</template>

<script>
      export default {
            name: 'topbar',
            methods:{
                  kefu:function () {
                        swal(
                              {
                                    title: '客服二维码',
                                    html: '<img src="kf.jpeg" width="100%">',
                                   
                                    type: '',
                                    confirmButtonColor: '#4fa7f3',
                              }
                        )
                  },
                  msg: function () {
                        
                        this.$axios({
                              method: 'get',
                              url: '/api/member2/msg_num',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                              this.num=response.data;

                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  showmember: function () {
                        //console.log(this.identity);
                        let data = {
                              tel: this.tel
                        }
                        this.$axios({
                              method: 'get',
                              url: '/api/member2/member_show',
                              data: data,
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {

                              this.tel=response.data.user.tel;
                              this.email=response.data.user.email;
                              this.lisname=response.data.user.name;

                              this.surname=response.data.information.surname;
                              this.name=response.data.information.name;
                              this.surname_en=response.data.information.surname_en;
                              this.name_en=response.data.information.name_en;
                              this.sex=response.data.information.sex;
                              this.Headquarters=response.data.information.Headquarters;
                              this.BranchOffice=response.data.information.BranchOffice;
                              this.WorkDepartment=response.data.information.WorkDepartment;
                              this.Jobduties=response.data.information.Jobduties;
                              this.address=response.data.information.address;


                        }.bind(this)).catch(function OnError() {

                        })

                  },
            },
            data(){
                  return{
                        i:0,
                        num:this.num,
                        lisname:this.lisname,
                  }
            },

            mounted() {
                  this.msg();
                  this.showmember();
            },
      }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >

  
     
</style>



// WEBPACK FOOTER //
// src/components/topbar.vue